import React from 'react'
import styled from 'styled-components'

import { SelectInput } from 'vqp-common'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: ${props => props.minWidth}
`

export const TextSelect = ({label, selected, onChange, options, minWidth}) => (
    <Wrapper minWidth={minWidth}>
        <SelectInput placeholder={label} selected={selected} onSelect={onChange} options={options} />
    </Wrapper>
)
